module.exports = __webpack_public_path__ + "3889b83933e10ea92644cc9799e190e2.pdf";